<div class="dynamic-modal-popup" (click)="close($event)">
  <div class="dynamic-modal-content width-max-500">
    <div class="am-flex-column am-flex-align gap-m">
      <span class="am-flex-column am-flex-align gap-xxs">
        <span class="font-s">Wir möchten Ihre Meinung wissen.</span>
        <span class="font-l">Wie zufrieden sind Sie mit der automatischen Texterkennung von Arbeitszeiten ?</span>
      </span>
      <div class="am-flex-center gap-xxl">
        <span class="am-flex-center font-80 hover-active-blue icon-thumb-up"   [class.color-blue]="rate ===  1" (click)="rate =  1" ></span>
        <span class="am-flex-center font-80 hover-active-blue icon-thumb-down" [class.color-blue]="rate === -1" (click)="rate = -1" ></span>
      </div>
      <div class="am-flex-center width-full pl-xl pr-xl">
        <textarea class="width-full p-s resize-none" [(ngModel)]="message" cols="30" rows="3" maxlength="255" placeholder="Was können wir verbessern ?"></textarea>
      </div>
      <button class="wide-btn blue" (click)="sendFeedback()" [disabled]="rate === null">Feedback senden</button>
    </div>
  </div>
</div>
